export const IsAiLoginInfoModal = "IsAiLoginInfoModal"
export const IsAiPaymentSuccessModal = "IsAiPaymentSuccessModal"
export const UserIPAddress = "UserIPAddress"
export const IsOrganizationUpdateModal = "OrganizationUpdateModal"
export const IsApiCancelOkayModal = "IsApiCancelOkayModal"
export const IsApiCancelOkayModal2 = "IsApiCancelOkayModal2"
export const IsModerModalApiLoadingDone = "IsModerModalApiLoadingDone"
export const IsBillingDetailsModal = "IsBillingDetailsModal"
export const IsBillingDetailsPCloseModal = "IsBillingDetailsPCloseModal"
